module.exports = __webpack_public_path__ + "img/r03.f47ec072.png";